import { connect } from 'react-redux'
import Component from 'components/DashboardTemplates/FormView/Metrics/Filter'

export default connect()(Component)
